"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var dateToTimestamp = function dateToTimestamp(date) {
  return date.getTime() / 1000;
};

var _default = dateToTimestamp;
exports["default"] = _default;